import { useLocation } from 'react-router-dom';
import { CommunityFaqRouter } from '../../../../util/RouterUtil';
import ViewWrapper from '../../../ViewWrapper';

const CommunityFaqRouterView = () => {
    const pathname = useLocation().pathname;
    return <ViewWrapper router={CommunityFaqRouter} />;
};

export default CommunityFaqRouterView;
